import Loader from "../components/Loader";
function SuspenseContent() {
  return (
    <div className="h-screenbg-base-100 flex w-full flex-col items-center pt-28">
      <Loader />
    </div>
  );
}

export default SuspenseContent;
